import { useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { RESET_PASSWORD_MUTATION, ME_QUERY, GET_EMAIL_FROM_RESET_TOKEN_QUERY } from "graphql/APICalls";
import { MapContext } from "providers/MapProvider";
import { PasswordInput } from "components/Helpers";

export default function ResetPasswordPage() {
  const { resetToken } = useParams();
  const navigate = useNavigate();
  const { updateLocation } = useContext(MapContext);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  const { data, loading: queryLoading, error: queryError } = useQuery(GET_EMAIL_FROM_RESET_TOKEN_QUERY, {
      variables: { resetToken }
  });

  const [resetPassword, { loading: mutationLoading }] = useMutation(RESET_PASSWORD_MUTATION);

  async function handleSubmit(e) {
    e.preventDefault();
    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match');
      return;
    }
    setErrorMessage('');
    resetPassword({
      variables: { resetToken, password },
      onCompleted: (data) => {
        if (data.resetPassword) {
            updateLocation();
            navigate('/');
        }
      },
      onError: (error) => {
        setErrorMessage(error.message);
      },
      refetchQueries: [{ query: ME_QUERY }]
    });
  }

  if (queryLoading) return <div className="centerer">Loading...</div>;
  
  const email = data?.getEmailFromResetToken;
  
  if (queryError || !email) return <div className="centerer">Error: Invalid or expired password reset link.</div>;

  return (
    <div className="auto-scrollbar">
      <div className="centerer login-signup-overlay">
        <form className="centered form-1" onSubmit={handleSubmit}>
          <h2>Reset Password</h2>
          <p>Resetting password for: <strong>{email}</strong></p>
          <label>New Password</label>
          <PasswordInput showPassword={showPassword} setShowPassword={setShowPassword} password={password} setPassword={setPassword} required/>
          <label>Confirm New Password</label>
          <PasswordInput showPassword={showPassword} setShowPassword={setShowPassword} password={confirmPassword} setPassword={setConfirmPassword} required/>
          <div className="wide error-message" style={{display: errorMessage.length ? 'block' : 'none'}}>{errorMessage}</div>
          <button type="submit" disabled={mutationLoading}>Reset Password & Log In</button>
        </form>
      </div>
    </div>
  );
} 